import React, { useEffect } from 'react';
import { useAppAuth } from '../../hooks/use-app-auth';
import { useRouterState } from '@tanstack/react-router';
import { last } from 'rambdax';

// Add type declaration for Datadog RUM
declare global {
  /* eslint-disable-next-line no-unused-vars */
  interface Window {
    DD_RUM?: {
      setUser: (user: {
        email?: string;
        id?: string;
        name?: string;
        [key: string]: any;
      }) => void;
      clearUser: () => void;
      startView: (options: { name: string, context: any }) => void;
    };
  }
}

// This component is used to track user and page views in Datadog
const DatadogUserTracking: React.FC = () => {
  const { isAuthenticated, user } = useAppAuth();
  // Get router state for tracking
  const routerState = useRouterState();

  // Track page views in Datadog
  useEffect(() => {
    // Use only location information for tracking
    const matchedRoute = last(routerState.matches);

    if (window.DD_RUM && window.DD_RUM.startView) {
      // Send the current view to Datadog
      window.DD_RUM.startView({
        name: matchedRoute.fullPath,
        context: { params: matchedRoute.params },
      });
    }
  }, [ routerState.matches ]); // Re-run when location changes

  // Track user identity in Datadog
  useEffect(() => {
    if (isAuthenticated && user && window.DD_RUM) {
      window.DD_RUM.setUser({
        email: user.email,
        id: user.sub,
        name: user.name,
      });
    } else if (!isAuthenticated && window.DD_RUM) {
      window.DD_RUM.clearUser();
    }
  }, [ isAuthenticated, user ]);

  return null; // nothing to render
};

export default DatadogUserTracking;
